import React from 'react';
import Checkbox from './Checkbox';

const ItemActions = ({
  item,
  onChange,
  type,
  identifier,
  dispatch,
  deleteItem,
  first,
  moveItemUp,
  last,
  moveItemDown,
  theme = 'light',
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex items-center">
        <Checkbox
          size="2.25rem"
          checked={item.enable}
          onChange={v => {
            onChange(`${identifier}.enable`, v);
          }}
          theme={theme}
        />

        <button
          type="button"
          onClick={() => deleteItem(dispatch, type, item)}
          className="ml-2 btn btn-danger"
        >
          <div className="flex items-center">
            <i className="material-icons mr-2 font-bold text-base">delete</i>
            <span className="text-sm">Delete</span>
          </div>
        </button>
      </div>

      <div className="flex">
        {!first && (
          <button
            type="button"
            onClick={() => moveItemUp(dispatch, type, item)}
            className={`${theme === 'light' ? 'btn-icon' : 'btn-icon-dark'} mr-2`}
          >
            <div className="flex items-center">
              <i className="material-icons font-bold text-base">arrow_upward</i>
            </div>
          </button>
        )}

        {!last && (
          <button
            type="button"
            onClick={() => moveItemDown(dispatch, type, item)}
            className={theme === 'light' ? 'btn-icon' : 'btn-icon-dark'}
          >
            <div className="flex items-center">
              <i className="material-icons font-bold text-base">arrow_downward</i>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default ItemActions;
